// daisyUI CSS 下拉（.dropdown 靠 :focus-within／hover 開合，沒有 React 開關狀態）補 Esc 關閉（2026-10-13 拍板：全站浮層可 Esc）。
// 焦點在下拉內時註冊 escapeLayers；按 Esc 加上 daisyUI 的 dropdown-close 強制收起，焦點回到觸發鈕（停在觸發鈕也不會又被 focus-within 打開）。
// 收起狀態在焦點離開下拉、觸發鈕再按 Enter／Space／點擊、或滑鼠重新移入時解除。沒按 Esc 前不加任何 class，滑鼠畫面不變。
// 用法：const dd = useFocusDropdown()
//   <div className={`dropdown ... ${dd.closeClass}`} {...dd.rootProps}>
//     <div tabIndex={0} role="button" {...dd.triggerProps}>…</div>   ← 觸發鈕＝下拉內第一個 [tabindex] 元素（daisyUI 慣例）
import { useRef, useState } from 'react'
import { useEscapeLayer } from './useEscapeLayer'

export function useFocusDropdown() {
  const [focused, setFocused] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  const rootRef = useRef(null) // 只在事件處理器裡寫入／讀取

  useEscapeLayer(focused && !dismissed, () => {
    setDismissed(true)
    rootRef.current?.querySelector('[tabindex]')?.focus()
  })

  const reopen = () => setDismissed(false)
  return {
    closeClass: dismissed ? 'dropdown-close' : '',
    rootProps: {
      onFocus: (e) => {
        rootRef.current = e.currentTarget
        setFocused(true)
      },
      onBlur: (e) => {
        if (e.currentTarget.contains(e.relatedTarget)) return
        setFocused(false)
        setDismissed(false)
      },
      onMouseEnter: reopen,
    },
    triggerProps: {
      onMouseDown: reopen,
      onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault() // Space 別捲動頁面
          reopen()
        }
      },
    },
  }
}
